import axios from "axios";
import { base_url } from "../../utils/baseUrl";
import { config } from "../../utils/axiosconfig";

const getWeeklyVcReviewList = async () => {
  const response = await axios.get(
    `${base_url}performance/weekly-vc-review-report`,
    config
  );
  return response.data;
};

const vcdashboardService = {  getWeeklyVcReviewList };

export default vcdashboardService;
